import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { SuccessPopupComponent } from '../components/success-popup/success-popup.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  updateFarmerScreenDataUrl = 'BuyingTransectional/AddFarmerScreenView';
  getFarmerScreenDataUrl = 'BuyingTransectional/GetFarmerScreenView';
  refresh = new BehaviorSubject(false);
  constructor(private http: HttpClient, private _snackBar: MatSnackBar) { }

  updateFarmerScreenData(payload: any) {
    return this.http.post<any>(environment.baseUrl + this.getFarmerScreenDataUrl, payload);
  }

  getFarmerScreenData() {
    return this.http.get<any>(environment.baseUrl + this.getFarmerScreenDataUrl);
  }

  getPurchaseSlip(id: number) {
    return this.http.get<any>(environment.baseUrl + 'BuyingTransectional/GetBuyerPrintingScreen?contractNo=' + id);
  }

  // it required on multiple modules
  getWarehouses() {
    return this.http.get<any>(environment.baseUrl + 'Location/GetWarehouses');
  }

  getWarehousesPbm() {
    return this.http.get<any>(environment.baseUrl + 'Location/GetWarehousesPBM');
  }

  // it required on multiple modules
  getLists(url: string) {
    return this.http.get<any>(environment.baseUrl + url);
  }

  getListsInfo(url: string, queryparams: any) {
    return this.http.get<any>(environment.baseUrl + url, {params: queryparams });
  }

  getGodownByLocation(id: any) {
    return this.http.post<any>(environment.baseUrl + 'Warehouse/Godown/GetGodownsByLocationId', {
      locationId: id
    });
  }


  getVoucherTransDetail(voucherId: number) {
    return this.http.post<any>(
      environment.baseUrl +
      'VoucherCorrection/GetAllVoucherByVoucherId', {
        voucherId: voucherId
      }

    );
  }

  showMessage(message: string) {
    this._snackBar.open(message || 'Something went wrong!', 'Close', {
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      duration: 3000
    });
  }


  delete(url: string, id: string) {
    return this.http.delete<any>(environment.baseUrl + url + '?id='+id);
  }

  // getTaxCertificat(contractId: number, purchaseGuid: number) {
  //   return this.http.get<any>(
  //     environment.baseUrl +
  //       'BuyingTransectional/getTaxCertificateData?contractId=' +
  //       contractId +
  //       '&purchaseId=' +
  //       purchaseGuid
  //   );
  // }


  getTaxCertificat(voucherId: number) {
    return this.http.post<any>(environment.baseUrl + 'VoucherCorrection/GetPrintCertificateDataByVoucherId', {VoucherId: voucherId});
  }

  getAllInfoRelatedtoMisVoucher(voucherId: any) {
    return this.http.post<any>(environment.baseUrl + `VoucherCorrection/GetAllVoucherByVoucherId`, {VoucherId: voucherId});
  }




  getAllGodowns() {
    return this.http.get<any>(environment.baseUrl + 'Warehouse/Godown/GetAllGodowns?statusFilter=all');
  }


}
